function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createSelector } from 'reselect';
import { convertToHexString } from '../utils';
import formatPropertySelectorCreator from './formatPropertySelectorCreator';
import widthSelector from './widthSelector';
const getMdPadding = formatPropertySelectorCreator('mdPadding');
const getComponentType = formatPropertySelectorCreator('componentType');
const getBackgroundColor = formatPropertySelectorCreator('backgroundColor');

// Cache for style objects to ensure stable references
// Uses LRU eviction to prevent unbounded memory growth
// Key: JSON stringified sorted style object entries, Value: style object
const MAX_CACHE_SIZE = 1000;
const styleObjectCache = new Map();

// Helper to get or create a cached style object
const getCachedStyleObject = style => {
  // Create a stable key from sorted style object entries
  // Use JSON.stringify to safely handle any value types and prevent collisions
  const styleEntries = Object.keys(style).sort().map(key => [key, style[key]]);
  const styleKey = JSON.stringify(styleEntries);
  if (styleObjectCache.has(styleKey)) {
    return styleObjectCache.get(styleKey);
  }

  // If cache is full, remove oldest entry (first in Map)
  if (styleObjectCache.size >= MAX_CACHE_SIZE) {
    const firstKey = styleObjectCache.keys().next().value;
    styleObjectCache.delete(firstKey);
  }

  // Create a new object and cache it
  const cachedStyle = _objectSpread({}, style);
  styleObjectCache.set(styleKey, cachedStyle);
  return cachedStyle;
};
export default createSelector([getMdPadding, widthSelector, getComponentType, getBackgroundColor], (padding, width, componentType, backgroundColor) => {
  const style = {};
  if (padding !== undefined) {
    const {
      top = 0,
      bottom = 0,
      left = 0,
      right = 0
    } = padding;
    const paddingTop = `${32 * top}px`;
    const paddingBottom = `${32 * bottom}px`;
    const paddingLeft = `${32 * left + 16}px`;
    const paddingRight = `${32 * right + 16}px`;
    style.paddingTop = paddingTop;
    style.paddingBottom = paddingBottom;
    style.paddingLeft = paddingLeft;
    style.paddingRight = paddingRight;
  }
  const noMarginOnTypes = ['column', 'grid', 'headerBar', 'subsection', 'section', 'row', 'collection', 'container', 'v1container'];
  if (!noMarginOnTypes.includes(componentType)) {
    style.marginBottom = '16px';
  }
  if (backgroundColor) {
    style.backgroundColor = convertToHexString(backgroundColor);
  }

  // Hide component if width is zero
  // widthSelector now consistently returns { size: <number> } objects for non-undefined widths
  if ((width === null || width === void 0 ? void 0 : width.size) === 0) {
    style.display = 'none';
  }

  // Return cached style object to ensure stable reference
  return getCachedStyleObject(style);
});